export default __webpack_public_path__ + "static/media/illustration-work-1-m.d85db902.webp";